import React from 'react'
import useDeviceSize, { DeviceSize } from '../hooks/useDeviceSize';
import DesktopModal from './DesktopModal';
import MobileDrawerModal from './MobileDrawerModal';

type Props = {
    children?: React.ReactNode;
    open: boolean;
    handleClose: () => void;
    px?: number;
    py?: number;
    width?: string;
    minWidth?: string;
}

const ResponsiveModal = (props: Props) => {
    const device = useDeviceSize();
    return (
        <>
            {device === DeviceSize.Desktop && (<>
                <DesktopModal {...props} />
            </>)}
            {device === DeviceSize.Mobile && (<>
                <MobileDrawerModal {...props} />
            </>)}
        </>
    )
}

export default ResponsiveModal